import { Project } from './project';
import { Injectable } from '@angular/core';
import { Ankieta } from './ankieta';

@Injectable({
  providedIn: 'root'
})
export class CompareProjectsService {
  private projects: Project[] = [];

  constructor() {
    if (localStorage.getItem('projects') === null) {
      this.projects = [];
    } else {
      this.projects = JSON.parse(localStorage.getItem('projects'));
      this.projects.forEach((project) => {
        project.ankieta = new Ankieta().deserialize(project.ankieta)
      });
    }
  }

  public addProject(project: Project) {
    let copy = Project.getCopy(project);
    // const index = this.projects.indexOf(project, 0);
    // if (index == -1) {
      if (this.projects.length == 2) {
        this.projects.shift();
      }
      this.projects.push(copy);
    // }
    this.saveProjects();
  }

  public getProjects(): Project[] {
    return this.projects;
  }

  public deleteProject(project: Project) {
    const index = this.projects.indexOf(project, 0);
    if (index > -1) {
      this.projects.splice(index, 1);
      this.saveProjects();
    }
  }

  private saveProjects() {
    localStorage.setItem('projects', JSON.stringify(this.projects));
  }
}
